import React, { useState } from "react";
import OutSideNavBar from "../outsideNavBar/OutSideNavBar";
import { IoIosArrowDown } from "react-icons/io";
import Footer from "../../Components/footer/Footer";

const FAQPage = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      q: "What is Pyramid Home Charger?",
      a: "Pyramid Home Charger is a compact EV charger designed for residential use, offering safe and efficient charging for your electric vehicle at home.",
      b: true,
    },
    {
      q: "Is the home charger compatible with all electric vehicles?",
      a: "Yes, our charger is compatible with all EVs that support the IEC 62196 Type 2 connector, which includes most electric vehicles in the market.",
      b: true,
    },
    {
      q: "How do I install a Pyramid charger at home?",
      a: "Installation is simple. A certified technician will visit your home to set up the charger safely. We provide full guidance and support during this process.",
      b: true,
    },
    {
      q: "Can I monitor the charger using a mobile app?",
      a: "Yes! Our mobile app allows you to track your charging sessions, manage settings, and view usage history in real-time from yourphone.",
      b: true,
    },
    {
      q: "What happens if my charger disconnects from the app?",
      a: "If your charger disconnects, it will continue charging as configured. Once reconnected, the app will sync the latest data automatically.",
      b: false,
    },
  ];

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="min-h-screen w-full bg-White">
      <OutSideNavBar />
      <main className="custom-container my-5 flex-grow-1 text-start">
        <h1 className="fw-bold mb-4">Frequently Asked Questions</h1>
        {faqs.map((item, idx) => (
          <div
            key={idx}
            className={`overflow-hidden mb-2 ${item.b ? "border-b" : ""}`}
          >
            <button
              onClick={() => toggleAccordion(idx)}
              className="w-full flex justify-between items-center py-4 px-2 text-left font-semibold"
            >
              {item.q}
              <span
                className={`transform transition-transform ${
                  openIndex === idx ? "rotate-180" : ""
                }`}
              >
                <IoIosArrowDown />
              </span>
            </button>
            {openIndex === idx && (
              <div className="p-4 text-gray-700">{item.a}</div>
            )}
          </div>
        ))}
      </main>
      <Footer />
    </div>
  );
};

export default FAQPage;
